import type {FC, ReactNode} from 'react';

/** `lockedClassName` for a fieldset wrapping multiple simultaneously-visible flex children. */
export const LOCKED_FLEX_COL_CLASSNAME = 'flex flex-col gap-6 pointer-events-none';

export interface ReadOnlyFieldsetProps {
  readOnly: boolean;
  children: ReactNode;
  /**
   * Classes applied to the fieldset only while locked. Pass layout classes here when the
   * locked fieldset wraps multiple simultaneously-visible children whose spacing would
   * otherwise come from the parent via the unlocked `display:contents` pass-through.
   */
  lockedClassName?: string;
}

/**
 * Locks a region of a form for read-only/review mode. A native `disabled` fieldset disables
 * every descendant control, so anything that must stay interactive (e.g. document
 * view/download) belongs OUTSIDE this wrapper. When unlocked the fieldset uses
 * `display:contents` so it is layout-transparent and children inherit the parent's layout;
 * when locked it becomes a real box so `disabled` and `pointer-events-none` take effect.
 */
export const ReadOnlyFieldset: FC<ReadOnlyFieldsetProps> = ({
  readOnly,
  children,
  lockedClassName = 'pointer-events-none'
}) => (
  <fieldset disabled={readOnly} className={readOnly ? lockedClassName : 'contents'}>
    {children}
  </fieldset>
);
